import Phaser from 'phaser';
import { AccessibilityMixin } from './AccessibilityMixin';

/**
 * @alias class.AccessibleContainer
 * @description Base class for containers with accessibility features
 */
class AccessibleContainer extends AccessibilityMixin(Phaser.GameObjects.Container) {}

export { AccessibleContainer };
